import { ca } from '@cian/analytics';

enum ETrackingFilterType {
  DownPayment = 'initial_fee',
  Term = 'mortgage_term',
}

export const trackDownPaymentFilterChange = (): void => trackFilterChange(ETrackingFilterType.DownPayment);
export const trackTermFilterChange = (): void => trackFilterChange(ETrackingFilterType.Term);

function trackFilterChange(filterType: ETrackingFilterType): void {
  ca('eventSite', {
    action: 'click_sopr',
    category: 'Promo',
    label: filterType,
    name: 'oldevent',
    useLastProducts: true,
  });
}
